import { PaymentList } from '@/models/api/payment/payment'
import { PaymentType } from '@/models/app-config/behavior/types'
import { compact } from 'lodash'

/**
 * 仕様として、の選択肢表示順を固定する
 * 今後決済方法が追加されたときに表示順未指定の場合は下に追加されるようにしておく
 * @see: https://my-color.esa.io/posts/625
 */
export const sortPaymentList = (payments: PaymentList): PaymentList => {
  const list = payments.list

  const sortedIds: PaymentType[] = [
    'atone',
    'paidy',
    'webmoney',
    'np-postpay',
    'cash-on-delivery',
    'cvs-number',
    'carrier',
  ]

  /**
   * ここでは順序を決めるだけで、特定の決済方法の存在や不在については強制・検証しない
   * 順序に定義されている決済方法が見つからない場合はスキップする
   * 順序に定義されていない決済方法が存在する場合はそれらをリストの最下部に順不同で連結する
   */
  const sorted = compact(
    sortedIds.map(id => list.find(payment => id === payment.id))
  ).concat(list.filter(payment => !sortedIds.find(id => id === payment.id)))

  return PaymentList.valueOf(sorted)
}
